import fireEvent from './fireEvent';

// Since we don't want to add the Tealium(utag) tracking to the iframes (because it will double-track with the parent)
// And since the parent page won't receive the click events from the iframes, we need to capture the clicks and fire the events.
function addClickTrackingHandler() {
	document.addEventListener('click', a => {
		if (a.target && a.target.dataset.trackClick) {
			const action = a.target.dataset.trackClick;
			fireEvent(action);
		}
	});
}

export default addClickTrackingHandler;
